// Auto-generated by scripts/postprocess-generated-types.py — do not edit.
// Re-run via pnpm generate:portal-api-types.
// Keys are kit-registration form fields that apply these max lengths in
// formValidations.ts / pcpValidation.ts. Adding a validated field: update
// PATIENT_REGISTRATION_LIMIT_FIELDS or PCP_LIMIT_FIELDS in the postprocess
// script and the corresponding rule array.

export const PATIENT_REGISTRATION_FIELD_LIMITS = {
  firstName: 45,
  lastName: 45,
  addressLine1: 64,
  addressLine2: 64,
  city: 45,
  state: 2,
  zipCode: 10,
  phone: 16,
  sexAssignedAtBirth: 8,
} as const

export const PCP_FIELD_LIMITS = {
  pcpName: 90,
  pcpFaxDigits: 10,
  pcpAddressLine1: 64,
  pcpAddressLine2: 64,
  pcpCity: 45,
  pcpState: 2,
  pcpZipCode: 10,
} as const

export const PCP_FAX_DIGIT_PATTERN = /^\d{10}$/
